var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_defined"},[_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"text"},[_vm._v("抱歉，没有找到页面")])])])
}]

export { render, staticRenderFns }